var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.$store.state.trajectory.trajectory.id)?_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":{ name: 'dashboard', param: {id: _vm.$store.state.trajectory.trajectory.id} }}},[_c('i',{staticClass:"icons icon-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('common.back_last_trajectory'))+"\n            ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43185190","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/BackToLastTrajectory.vue
// module id = 1180
// module chunks = 1 2